"use strict";

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* Smart Earth Camelina — site header (React)
 * Pre-compiled from JSX → assets/se-header.js via Babel.
 *
 * Globals expected (set by theme.liquid):
 *   window.SE_LOGO_URL  — string (asset_url of the brand logo image)
 *   window.__customer   — Shopify customer object (or null when logged out)
 *
 * Renders into:
 *   #se-header-root        (desktop, sticky)
 *   #se-mobile-header-root (mobile drawer contents)
 *   #se-mobile-bar         (mobile sticky bar; logo + hamburger, static markup)
 *
 * Owns:
 *   #cp2-cart-drawer + #cp2-cart-ov  (created on demand by cart code)
 *   #se-drawer-wrap + #se-drawer-overlay (mobile menu drawer wrapper, static markup)
 */

const LOGO_URL = window.SE_LOGO_URL || '';

/* ───────────────────────── data ───────────────────────── */

const MENU = [{
  label: "Horses",
  href: "/collections/equine",
  children: [{
    label: "Joint + Coat Health",
    href: "/collections/equine/products/equine-jug",
    desc: "Daily camelina oil for shine & joint support"
  }, {
    label: "Gastric Wellness",
    href: "/products/camelina-plus-gastric-wellness-support",
    desc: "Camelina Plus for ulcer-prone horses"
  }, {
    label: "Subscribe & Save",
    href: "/products/subscriptions",
    desc: "Recurring delivery, never run out"
  }, {
    label: "Shop All Equine",
    href: "/collections/equine",
    desc: "Browse the full equine range"
  }]
}, {
  label: "Dogs",
  href: "/collections/small-pets",
  children: [{
    label: "Skin + Coat Health",
    href: "/collections/small-pets/products/camelina-oil-for-canine-16oz",
    desc: "Omega-3 oil for shinier coats"
  }, {
    label: "Subscribe & Save",
    href: "/products/subscriptions",
    desc: "Recurring delivery for your dog"
  }, {
    label: "Shop All Canine",
    href: "/collections/small-pets",
    desc: "Browse the full canine range"
  }]
}, {
  label: "Why Camelina",
  href: "/pages/about-us",
  children: [{
    label: "What is Camelina Oil",
    href: "/pages/about-us",
    desc: "The science behind the seed"
  }, {
    label: "Reviews",
    href: "/pages/reviews",
    desc: "Real owners, real results"
  }, {
    label: "Equine FAQs",
    href: "/pages/equine-faqs",
    desc: "Common horse questions answered"
  }, {
    label: "Canine FAQs",
    href: "/pages/canine-faqs",
    desc: "Common dog questions answered"
  }]
}, {
  label: "Find a Store",
  href: "/pages/store-finder"
}, {
  label: "Partners",
  href: "/pages/partner"
}, {
  label: "Blog",
  href: "/blogs/news"
}];
const SUBSCRIPTIONS_URL = "https://account.smartearthcamelina.ca/";

/* ───────────────────────── icons ───────────────────────── */

const Icon = {
  Search: p => /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.6",
    strokeLinecap: "round"
  }, p), /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "11",
    r: "6.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20 20-4-4"
  })),
  User: p => /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, p), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "8.5",
    r: "3.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 20c1.5-3.5 4.5-5 7.5-5s6 1.5 7.5 5"
  })),
  ArrowRight: p => /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, p), /*#__PURE__*/React.createElement("path", {
    d: "M5 12h14m-5-6 6 6-6 6"
  })),
  Close: p => /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.6",
    strokeLinecap: "round"
  }, p), /*#__PURE__*/React.createElement("path", {
    d: "M6 6 18 18M18 6 6 18"
  }))
};

/* ───────────────────────── shared tokens ───────────────────────── */

const tokens = {
  bg: "#F5F5F2",
  surface: "#FFFFFF",
  ink: "#0E1411",
  green: "#02a74f",
  greenDeep: "#0E2A1B",
  muted: "rgba(14,20,17,0.55)",
  rule: "rgba(14,20,17,0.10)"
};

/* ───────────────────────── search ───────────────────────── */

function useDebounced(value, ms) {
  const [v, setV] = React.useState(value);
  React.useEffect(() => {
    const t = setTimeout(() => setV(value), ms);
    return () => clearTimeout(t);
  }, [value, ms]);
  return v;
}
function SearchPanel({
  open,
  onClose
}) {
  const [q, setQ] = React.useState("");
  const debounced = useDebounced(q, 200);
  const [results, setResults] = React.useState({
    products: [],
    collections: [],
    pages: []
  });
  const [loading, setLoading] = React.useState(false);
  const inputRef = React.useRef(null);
  React.useEffect(() => {
    if (open && inputRef.current) inputRef.current.focus();
  }, [open]);
  React.useEffect(() => {
    if (!debounced) {
      setResults({
        products: [],
        collections: [],
        pages: []
      });
      return;
    }
    setLoading(true);
    const ctrl = new AbortController();
    const url = `/search/suggest.json?q=${encodeURIComponent(debounced)}&resources[type]=product,collection,page&resources[options][unavailable_products]=hide&resources[limit]=6`;
    fetch(url, {
      signal: ctrl.signal,
      credentials: "same-origin"
    }).then(r => r.json()).then(j => {
      const r = j.resources?.results || {};
      setResults({
        products: r.products || [],
        collections: r.collections || [],
        pages: r.pages || []
      });
      setLoading(false);
    }).catch(() => setLoading(false));
    return () => ctrl.abort();
  }, [debounced]);
  React.useEffect(() => {
    if (!open) return;
    const onKey = e => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);
  if (!open) return null;
  const {
    surface,
    ink,
    muted,
    rule,
    green
  } = tokens;
  const hasResults = results.products.length || results.collections.length || results.pages.length;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: 0,
      right: 0,
      top: "100%",
      background: surface,
      borderTop: `1px solid ${rule}`,
      borderBottom: `1px solid ${rule}`,
      zIndex: 60,
      boxShadow: "0 30px 40px -24px rgba(14,20,17,0.10)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 1440,
      margin: "0 auto",
      padding: "20px 40px"
    }
  }, /*#__PURE__*/React.createElement("form", {
    action: "/search",
    method: "get",
    style: {
      display: "flex",
      alignItems: "center",
      gap: 12,
      borderBottom: `1px solid ${rule}`,
      paddingBottom: 12
    }
  }, /*#__PURE__*/React.createElement(Icon.Search, {
    width: "18",
    height: "18",
    style: {
      color: muted
    }
  }), /*#__PURE__*/React.createElement("input", {
    ref: inputRef,
    type: "search",
    name: "q",
    value: q,
    onChange: e => setQ(e.target.value),
    placeholder: "Search products, articles\u2026",
    style: {
      flex: 1,
      border: "none",
      outline: "none",
      background: "transparent",
      fontFamily: "'Raleway', sans-serif",
      fontSize: 18,
      color: ink,
      padding: "8px 0"
    }
  }), /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: onClose,
    "aria-label": "Close search",
    style: {
      background: "transparent",
      border: "none",
      color: muted,
      cursor: "pointer",
      padding: 4
    }
  }, /*#__PURE__*/React.createElement(Icon.Close, {
    width: "18",
    height: "18"
  }))), !q && /*#__PURE__*/React.createElement("div", {
    style: {
      padding: "16px 0 0",
      fontSize: 13,
      color: muted,
      fontFamily: "'Montserrat', monospace",
      letterSpacing: "0.12em",
      textTransform: "uppercase"
    }
  }, "Try \u201Cequine jug\u201D, \u201Ccanine oil\u201D, or \u201Creviews\u201D"), q && !loading && !hasResults && /*#__PURE__*/React.createElement("div", {
    style: {
      padding: "20px 0",
      fontSize: 14,
      color: muted
    }
  }, "No matches for \u201C", q, "\u201D."), hasResults && /*#__PURE__*/React.createElement("div", {
    style: {
      display: "grid",
      gridTemplateColumns: "1.6fr 1fr 1fr",
      gap: 32,
      paddingTop: 18
    }
  }, /*#__PURE__*/React.createElement(SearchGroup, {
    title: "Products",
    items: results.products.map(p => ({
      key: p.id,
      href: p.url,
      label: p.title,
      sub: p.price ? formatPrice(p.price) : null,
      img: p.featured_image?.url || p.image
    })),
    muted: muted,
    ink: ink,
    green: green,
    rule: rule
  }), /*#__PURE__*/React.createElement(SearchGroup, {
    title: "Collections",
    items: results.collections.map(c => ({
      key: c.id,
      href: c.url,
      label: c.title
    })),
    muted: muted,
    ink: ink,
    green: green,
    rule: rule
  }), /*#__PURE__*/React.createElement(SearchGroup, {
    title: "Pages",
    items: results.pages.map(p => ({
      key: p.id,
      href: p.url,
      label: p.title
    })),
    muted: muted,
    ink: ink,
    green: green,
    rule: rule
  }))));
}
function SearchGroup({
  title,
  items,
  muted,
  ink,
  green,
  rule
}) {
  if (!items.length) return null;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: "'Montserrat', monospace",
      fontSize: 10,
      color: green,
      letterSpacing: "0.18em",
      textTransform: "uppercase",
      marginBottom: 10
    }
  }, title), /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: "none",
      margin: 0,
      padding: 0,
      display: "flex",
      flexDirection: "column",
      gap: 8
    }
  }, items.map(it => /*#__PURE__*/React.createElement("li", {
    key: it.key
  }, /*#__PURE__*/React.createElement("a", {
    href: it.href,
    style: {
      display: "flex",
      alignItems: "center",
      gap: 12,
      padding: "8px 0",
      textDecoration: "none",
      color: ink,
      borderBottom: `1px solid ${rule}`
    }
  }, it.img && /*#__PURE__*/React.createElement("img", {
    src: it.img,
    alt: "",
    width: "44",
    height: "44",
    style: {
      borderRadius: 6,
      objectFit: "cover",
      background: "#F5F5F2",
      flex: "0 0 auto"
    }
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      flex: 1,
      minWidth: 0
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: "block",
      fontSize: 14,
      lineHeight: 1.3
    }
  }, it.label), it.sub && /*#__PURE__*/React.createElement("span", {
    style: {
      display: "block",
      fontSize: 12,
      color: muted,
      marginTop: 2
    }
  }, it.sub)))))));
}
function formatPrice(p) {
  // /search/suggest.json returns price strings already formatted, but if it's a number treat as cents.
  if (typeof p === "string") return p;
  return "$" + (Math.round(p) / 100).toFixed(2);
}

/* ───────────────────────── account dropdown ───────────────────────── */

function AccountDropdown({
  open,
  onClose,
  anchorRef
}) {
  const customer = window.__customer || null;
  const ref = React.useRef(null);
  React.useEffect(() => {
    if (!open) return;
    const onDown = e => {
      if (ref.current && !ref.current.contains(e.target) && anchorRef.current && !anchorRef.current.contains(e.target)) onClose();
    };
    const onKey = e => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("mousedown", onDown);
    window.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDown);
      window.removeEventListener("keydown", onKey);
    };
  }, [open, onClose, anchorRef]);
  if (!open) return null;
  const {
    surface,
    ink,
    muted,
    rule,
    green
  } = tokens;
  const item = {
    display: "block",
    padding: "10px 14px",
    textDecoration: "none",
    color: ink,
    fontSize: 14,
    borderRadius: 6
  };
  const itemHover = e => e.currentTarget.style.background = "#F5F5F2";
  const itemLeave = e => e.currentTarget.style.background = "transparent";
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    style: {
      position: "absolute",
      right: 0,
      top: "calc(100% + 8px)",
      minWidth: 240,
      background: surface,
      border: `1px solid ${rule}`,
      borderRadius: 10,
      boxShadow: "0 12px 28px -10px rgba(14,20,17,0.18)",
      padding: 8,
      zIndex: 70
    }
  }, customer ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      padding: "8px 14px 10px",
      borderBottom: `1px solid ${rule}`,
      marginBottom: 6
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: "'Montserrat', monospace",
      fontSize: 10,
      color: green,
      letterSpacing: "0.18em",
      textTransform: "uppercase"
    }
  }, "Signed in"), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 15,
      fontWeight: 500,
      color: ink,
      marginTop: 2
    }
  }, customer.first_name || customer.email || "Account")), /*#__PURE__*/React.createElement("a", {
    href: "/account",
    style: item,
    onMouseEnter: itemHover,
    onMouseLeave: itemLeave
  }, "Account home"), /*#__PURE__*/React.createElement("a", {
    href: "/account/orders",
    style: item,
    onMouseEnter: itemHover,
    onMouseLeave: itemLeave
  }, "Orders"), /*#__PURE__*/React.createElement("a", {
    href: SUBSCRIPTIONS_URL,
    style: item,
    onMouseEnter: itemHover,
    onMouseLeave: itemLeave
  }, "Subscriptions \u2197"), /*#__PURE__*/React.createElement("a", {
    href: "/account/addresses",
    style: item,
    onMouseEnter: itemHover,
    onMouseLeave: itemLeave
  }, "Addresses"), /*#__PURE__*/React.createElement("a", {
    href: "/account/logout",
    style: {
      ...item,
      color: muted
    },
    onMouseEnter: itemHover,
    onMouseLeave: itemLeave
  }, "Log out")) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
    href: "/account/login",
    style: {
      ...item,
      background: ink,
      color: "#FFFFFF",
      textAlign: "center",
      fontWeight: 600,
      marginBottom: 4
    }
  }, "Log in"), /*#__PURE__*/React.createElement("a", {
    href: "/account/register",
    style: {
      ...item,
      textAlign: "center",
      border: `1px solid ${rule}`
    }
  }, "Create account")));
}

/* ───────────────────────── cart count badge ───────────────────────── */

function useCartCount() {
  const [n, setN] = React.useState(0);
  React.useEffect(() => {
    let mounted = true;
    function load() {
      fetch("/cart.js", {
        credentials: "same-origin"
      }).then(r => r.json()).then(c => {
        if (mounted) setN(c.item_count || 0);
      }).catch(() => {});
    }
    load();
    // Listen for cart-update events from this and other code paths
    const handler = () => load();
    window.addEventListener("se:cart-updated", handler);
    document.addEventListener("cart:refresh", handler);
    return () => {
      mounted = false;
      window.removeEventListener("se:cart-updated", handler);
      document.removeEventListener("cart:refresh", handler);
    };
  }, []);
  return n;
}

/* ───────────────────────── desktop header ───────────────────────── */

function HeaderDesktop() {
  const [hover, setHover] = React.useState(null);
  const [accountOpen, setAccountOpen] = React.useState(false);
  const accountAnchor = React.useRef(null);
  const cartCount = useCartCount();
  const {
    bg,
    surface,
    ink,
    green,
    greenDeep,
    muted,
    rule
  } = tokens;
  const iconBtn = {
    background: surface,
    border: `1px solid ${rule}`,
    color: ink,
    cursor: "pointer",
    width: 38,
    height: 38,
    borderRadius: "50%",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative"
  };
  return /*#__PURE__*/React.createElement("div", {
    style: {
      background: bg,
      color: ink,
      fontFamily: "'Raleway', sans-serif",
      position: "relative"
    },
    onMouseLeave: () => setHover(null)
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      borderBottom: `1px solid ${rule}`,
      fontFamily: "'Montserrat', monospace",
      fontSize: 11,
      letterSpacing: "0.12em",
      textTransform: "uppercase"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 1440,
      margin: "0 auto",
      padding: "10px 40px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      color: muted
    }
  }, /*#__PURE__*/React.createElement("span", null, "[ NON-GMO \xB7 COLD PRESSED \xB7 GROWN IN CANADA ]"), /*#__PURE__*/React.createElement("span", {
    style: {
      display: "inline-flex",
      alignItems: "center",
      gap: 6,
      color: ink,
      fontWeight: 600,
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      width: 6,
      height: 6,
      borderRadius: "50%",
      background: green,
      boxShadow: "0 0 0 3px rgba(2,167,79,0.18)"
    }
  }), "Free Shipping > $100"), /*#__PURE__*/React.createElement("span", {
    style: {
      display: "flex",
      gap: 22,
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement("a", {
    style: {
      color: muted,
      textDecoration: "none"
    },
    href: "/pages/store-finder"
  }, "FIND A STORE"), /*#__PURE__*/React.createElement("a", {
    style: {
      color: muted,
      textDecoration: "none"
    },
    href: window.__customer ? "/account" : "/account/login"
  }, "ACCOUNT"), /*#__PURE__*/React.createElement("svg", {
    width: "22",
    height: "11",
    viewBox: "0 0 24 12",
    "aria-label": "Canada",
    style: {
      flexShrink: 0,
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "12",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "6",
    height: "12",
    fill: "#D52B1E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "18",
    width: "6",
    height: "12",
    fill: "#D52B1E"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D52B1E",
    d: "M12 2.5l.7 1.5 1.6-.3-.5 1.4 1 .7-1.3.3.3 1.2-1-.4-.8 1.7-.8-1.7-1 .4.3-1.2-1.3-.3 1-.7-.5-1.4 1.6.3z"
  }))))), /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 1440,
      margin: "0 auto",
      padding: "20px 40px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 32
    }
  }, /*#__PURE__*/React.createElement("a", {
    href: "/",
    style: {
      textDecoration: "none",
      color: ink,
      display: "inline-flex",
      alignItems: "center",
      lineHeight: 0
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: LOGO_URL,
    alt: "Smart Earth Camelina",
    style: {
      height: 36,
      width: "auto",
      display: "block"
    }
  })), /*#__PURE__*/React.createElement("nav", {
    className: "se-pill-nav",
    style: {
      display: "flex",
      alignItems: "center",
      gap: 2,
      padding: 4,
      borderRadius: 999,
      border: `1px solid ${rule}`,
      background: surface
    }
  }, MENU.map((item, i) => /*#__PURE__*/React.createElement("a", {
    key: item.label,
    href: item.href,
    className: "se-pill-link",
    onMouseEnter: () => setHover(i),
    style: {
      textDecoration: "none",
      color: hover === i ? "#FFFFFF" : ink,
      fontSize: 13,
      fontWeight: 500,
      padding: "9px 16px",
      borderRadius: 999,
      background: hover === i ? green : "transparent",
      transition: "all .15s",
      display: "inline-flex",
      alignItems: "center",
      gap: 5,
      letterSpacing: "-0.01em"
    }
  }, item.label, item.children && /*#__PURE__*/React.createElement("span", {
    style: {
      opacity: 0.7,
      fontSize: 10
    }
  }, "\u2193")))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: 8,
      position: "relative"
    }
  }, /*#__PURE__*/React.createElement("div", {
    ref: accountAnchor,
    style: {
      position: "relative"
    }
  }, /*#__PURE__*/React.createElement("button", {
    style: iconBtn,
    "aria-label": "Account",
    onClick: () => setAccountOpen(o => !o)
  }, /*#__PURE__*/React.createElement(Icon.User, {
    width: "16",
    height: "16"
  })), /*#__PURE__*/React.createElement(AccountDropdown, {
    open: accountOpen,
    onClose: () => setAccountOpen(false),
    anchorRef: accountAnchor
  })), /*#__PURE__*/React.createElement("a", {
    href: "/cart",
    style: {
      textDecoration: "none",
      display: "inline-flex",
      alignItems: "center",
      gap: 8,
      background: ink,
      color: "#FFFFFF",
      padding: "10px 16px",
      borderRadius: 999,
      fontWeight: 600,
      fontSize: 13,
      fontFamily: "'Montserrat', monospace",
      letterSpacing: "0.05em"
    }
  }, "CART(", cartCount, ")"))), hover != null && MENU[hover]?.children && /*#__PURE__*/React.createElement("div", {
    onMouseEnter: () => setHover(hover),
    style: {
      position: "absolute",
      left: 0,
      right: 0,
      top: "100%",
      background: surface,
      borderTop: `1px solid ${rule}`,
      borderBottom: `1px solid ${rule}`,
      zIndex: 5,
      boxShadow: "0 30px 40px -24px rgba(14,20,17,0.10)"
    }
  }, /*#__PURE__*/React.createElement(Mega3Col, {
    item: MENU[hover]
  })));
}
function Mega3Col({
  item
}) {
  const {
    ink,
    muted,
    green,
    greenDeep,
    bg,
    rule
  } = tokens;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 1440,
      margin: "0 auto",
      padding: "44px 40px 48px",
      display: "grid",
      gridTemplateColumns: "320px 1fr 280px",
      gap: 48,
      alignItems: "start"
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
    className: "se-mega-cat",
    style: {
      margin: "0 0 14px",
      fontSize: 38,
      fontWeight: 700,
      letterSpacing: "-0.035em",
      lineHeight: 1.05,
      color: ink
    }
  }, item.label), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: "0 0 18px",
      fontSize: 13,
      color: muted,
      lineHeight: 1.55
    }
  }, item.label === "Horses" ? "Single-ingredient camelina oil and gastric support, formulated with North American grown seed." : item.label === "Dogs" ? "Cold-pressed omega-3 oil for shinier coats, better skin and healthier joints." : "Get familiar with the science behind one of the world's oldest oilseeds."), /*#__PURE__*/React.createElement("a", {
    href: item.href,
    style: {
      display: "inline-flex",
      alignItems: "center",
      gap: 8,
      color: ink,
      textDecoration: "none",
      fontSize: 12,
      fontFamily: "'Montserrat', monospace",
      letterSpacing: "0.15em",
      textTransform: "uppercase",
      borderBottom: `1px solid ${ink}`,
      paddingBottom: 4
    }
  }, "View all \u2192")), /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: "none",
      margin: 0,
      padding: 0,
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: 0,
      border: `1px solid ${rule}`,
      borderRadius: 8,
      overflow: "hidden",
      background: bg
    }
  }, item.children.map((c, i) => /*#__PURE__*/React.createElement("li", {
    key: c.label,
    style: {
      borderRight: i % 2 === 0 ? `1px solid ${rule}` : "none",
      borderBottom: i < item.children.length - 2 ? `1px solid ${rule}` : "none",
      background: "#FFFFFF"
    }
  }, /*#__PURE__*/React.createElement("a", {
    href: c.href,
    style: {
      display: "block",
      padding: 18,
      textDecoration: "none",
      color: ink,
      transition: "background .15s"
    },
    onMouseEnter: e => e.currentTarget.style.background = "#FAFAF7",
    onMouseLeave: e => e.currentTarget.style.background = ""
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end"
    }
  }, /*#__PURE__*/React.createElement(Icon.ArrowRight, {
    width: "14",
    height: "14",
    style: {
      color: muted
    }
  })), /*#__PURE__*/React.createElement("h4", {
    className: "se-mega-item",
    style: {
      margin: "4px 0 0",
      fontSize: 17,
      fontWeight: 700,
      lineHeight: 1,
      letterSpacing: "-0.01em",
      color: "inherit"
    }
  }, c.label), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontSize: 12.5,
      color: muted,
      lineHeight: 1.45
    }
  }, c.desc))))), /*#__PURE__*/React.createElement("a", {
    href: item.label === "Horses" ? "/products/camelina-plus-gastric-wellness-support" : item.label === "Dogs" ? "/products/camelina-oil-for-canine-16oz" : "/pages/about-us",
    className: "se-featured-card",
    style: {
      textDecoration: "none",
      color: "#FFFFFF",
      background: greenDeep,
      borderRadius: 8,
      padding: 22,
      display: "flex",
      flexDirection: "column",
      gap: 14,
      minHeight: 180,
      position: "relative",
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: "'Montserrat', monospace",
      fontSize: 10,
      color: green,
      letterSpacing: "0.18em"
    }
  }, "FEATURED \xB7 NEW"), /*#__PURE__*/React.createElement("h4", {
    className: "se-mega-feat",
    style: {
      margin: "auto 0 0",
      fontSize: 22,
      fontWeight: 700,
      letterSpacing: "-0.02em",
      lineHeight: 1.2,
      color: "inherit"
    }
  }, item.label === "Horses" ? "Camelina Plus — engineered for sensitive guts." : item.label === "Dogs" ? "Cold-pressed canine oil. 16 & 64 oz." : "Why the world's oldest seed is the right one."), /*#__PURE__*/React.createElement("span", {
    style: {
      display: "inline-flex",
      alignItems: "center",
      gap: 6,
      fontSize: 12,
      fontFamily: "'Montserrat', monospace",
      letterSpacing: "0.18em",
      textTransform: "uppercase",
      opacity: 0.9
    }
  }, "Shop now ", /*#__PURE__*/React.createElement(Icon.ArrowRight, {
    width: "12",
    height: "12"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      right: -30,
      bottom: -30,
      width: 140,
      height: 140,
      background: green,
      opacity: 0.18,
      borderRadius: "50%"
    }
  })));
}

/* ───────────────────────── mobile drawer ───────────────────────── */

function HeaderMobile() {
  const {
    bg,
    surface,
    ink,
    green,
    muted,
    rule
  } = tokens;
  const [expanded, setExpanded] = React.useState("Horses");
  const cartCount = useCartCount();
  const customer = window.__customer || null;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      background: bg,
      color: ink,
      fontFamily: "'Raleway', sans-serif",
      height: "100%",
      display: "flex",
      flexDirection: "column"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      padding: "14px 18px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      borderBottom: `1px solid ${rule}`,
      background: surface
    }
  }, /*#__PURE__*/React.createElement("a", {
    href: "/",
    style: {
      textDecoration: "none",
      color: ink,
      display: "inline-flex",
      alignItems: "center",
      lineHeight: 0
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: LOGO_URL,
    alt: "Smart Earth Camelina",
    style: {
      height: 28,
      width: "auto",
      display: "block"
    }
  })), /*#__PURE__*/React.createElement("button", {
    style: {
      background: surface,
      border: `1px solid ${rule}`,
      color: ink,
      cursor: "pointer",
      width: 36,
      height: 36,
      borderRadius: "50%",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center"
    },
    "aria-label": "Close"
  }, /*#__PURE__*/React.createElement(Icon.Close, {
    width: "18",
    height: "18"
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1,
      overflowY: "auto",
      padding: "14px 18px"
    }
  }, MENU.map((item, idx) => {
    const rowStyle = {
      width: "100%",
      background: "transparent",
      border: "none",
      padding: "16px 0",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      cursor: "pointer",
      color: ink,
      textDecoration: "none",
      textAlign: "left",
      boxSizing: "border-box"
    };
    const labelInner = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      style: {
        fontSize: 22,
        fontWeight: 500,
        letterSpacing: "-0.02em"
      }
    }, item.label), item.children ? /*#__PURE__*/React.createElement("span", {
      style: {
        color: muted,
        transition: "transform .2s",
        transform: expanded === item.label ? "rotate(45deg)" : "rotate(0)",
        fontSize: 20
      }
    }, "+") : /*#__PURE__*/React.createElement(Icon.ArrowRight, {
      width: "18",
      height: "18",
      style: {
        color: muted
      }
    }));
    return /*#__PURE__*/React.createElement("div", {
      key: item.label,
      style: {
        borderBottom: `1px solid ${rule}`
      }
    }, item.children ? /*#__PURE__*/React.createElement("button", {
      onClick: () => setExpanded(expanded === item.label ? null : item.label),
      style: rowStyle
    }, labelInner) : /*#__PURE__*/React.createElement("a", {
      href: item.href,
      style: rowStyle
    }, labelInner), item.children && expanded === item.label && /*#__PURE__*/React.createElement("div", {
      style: {
        padding: "0 0 16px"
      }
    }, item.children.map(c => /*#__PURE__*/React.createElement("a", {
      key: c.label,
      href: c.href,
      style: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "10px 0 10px 28px",
        textDecoration: "none",
        color: muted,
        fontSize: 14
      }
    }, /*#__PURE__*/React.createElement("span", null, c.label), /*#__PURE__*/React.createElement(Icon.ArrowRight, {
      width: "13",
      height: "13"
    })))));
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      borderBottom: `1px solid ${rule}`,
      padding: "16px 0",
      display: "flex",
      flexDirection: "column",
      gap: 10
    }
  }, customer ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
    href: "/account",
    style: {
      color: ink,
      textDecoration: "none",
      fontSize: 15
    }
  }, "Account"), /*#__PURE__*/React.createElement("a", {
    href: "/account/orders",
    style: {
      color: ink,
      textDecoration: "none",
      fontSize: 15
    }
  }, "Orders"), /*#__PURE__*/React.createElement("a", {
    href: SUBSCRIPTIONS_URL,
    style: {
      color: ink,
      textDecoration: "none",
      fontSize: 15
    }
  }, "Subscriptions \u2197"), /*#__PURE__*/React.createElement("a", {
    href: "/account/logout",
    style: {
      color: muted,
      textDecoration: "none",
      fontSize: 14
    }
  }, "Log out")) : /*#__PURE__*/React.createElement("a", {
    href: "/account/login",
    style: {
      color: ink,
      textDecoration: "none",
      fontSize: 15
    }
  }, "Log in / Sign up"))), /*#__PURE__*/React.createElement("div", {
    style: {
      padding: 18,
      borderTop: `1px solid ${rule}`,
      display: "flex",
      flexDirection: "column",
      gap: 10,
      background: surface
    }
  }, /*#__PURE__*/React.createElement("a", {
    href: "/cart",
    style: {
      textDecoration: "none",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      background: ink,
      color: "#FFFFFF",
      padding: "14px 18px",
      borderRadius: 999,
      fontWeight: 600,
      fontSize: 14,
      fontFamily: "'Montserrat', monospace",
      letterSpacing: "0.06em"
    }
  }, /*#__PURE__*/React.createElement("span", null, "My Cart"), /*#__PURE__*/React.createElement("span", null, cartCount, " ITEM", cartCount === 1 ? "" : "S"))));
}

/* ───────────────────────── cart drawer (vanilla, attaches to <a href="/cart">) ───────────────────────── */

function money(n) {
  return "$" + (Math.round(n * 100) / 100).toFixed(2);
}
function ensureDrawer() {
  let d = document.getElementById("cp2-cart-drawer");
  if (d) return d;
  const o = document.createElement("div");
  o.id = "cp2-cart-ov";
  document.body.appendChild(o);
  o.addEventListener("click", closeDrawer);
  d = document.createElement("div");
  d.id = "cp2-cart-drawer";
  document.body.appendChild(d);
  return d;
}
function renderDrawer(cart) {
  const d = ensureDrawer(),
    o = document.getElementById("cp2-cart-ov");
  const items = cart.items && cart.items.length ? cart.items.map(i => {
    // Subscription line items: link back to the subscription page rather than
    // the base product so customers can edit their subscription pick.
    const isSub = !!i.selling_plan_allocation;
    const lineUrl = isSub ? "/products/subscriptions" : i.url || "#";
    const planLabel = isSub ? `<div class="cp2cd-it-plan">${escapeHtml(i.selling_plan_allocation.selling_plan.name)}</div>` : "";
    return `<div class="cp2cd-item"><a href="${lineUrl}" class="cp2cd-it-img"><img src="${i.image || ""}" alt=""></a><div class="cp2cd-it-c"><a href="${lineUrl}" class="cp2cd-it-t">${escapeHtml(i.product_title)}</a>${planLabel}<div class="cp2cd-it-m">QTY ${i.quantity} · ${money(i.final_line_price / 100)}</div><button class="cp2cd-rm" data-key="${i.key}">Remove</button></div></div>`;
  }).join("") : '<div class="cp2cd-empty">Your cart is empty</div>';
  d.innerHTML = `<div class="cp2cd-hd"><span>Your cart</span><button class="cp2cd-x" aria-label="Close">×</button></div><div class="cp2cd-items">${items}</div><div class="cp2cd-ft"><div class="cp2cd-sub"><span>SUBTOTAL</span><span>${money((cart.total_price || 0) / 100)}</span></div><a class="cp2cd-co" href="/checkout">CHECKOUT →</a><a class="cp2cd-vc" href="/cart">View cart</a></div>`;
  d.querySelector(".cp2cd-x").addEventListener("click", closeDrawer);
  d.querySelectorAll(".cp2cd-rm").forEach(b => {
    b.addEventListener("click", () => {
      fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        credentials: "same-origin",
        body: JSON.stringify({
          id: b.dataset.key,
          quantity: 0
        })
      }).then(r => r.json()).then(c => {
        renderDrawer(c);
        window.dispatchEvent(new CustomEvent("se:cart-updated", {
          detail: c
        }));
      }).catch(() => {});
    });
  });
  requestAnimationFrame(() => {
    o.classList.add("on");
    d.classList.add("on");
  });
}
function openDrawer() {
  fetch("/cart.js", {
    credentials: "same-origin"
  }).then(r => r.json()).then(renderDrawer).catch(() => {
    window.location.href = "/cart";
  });
}
function closeDrawer() {
  const d = document.getElementById("cp2-cart-drawer"),
    o = document.getElementById("cp2-cart-ov");
  if (d) d.classList.remove("on");
  if (o) o.classList.remove("on");
}
function escapeHtml(s) {
  return String(s || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}
function wireCartLinks() {
  document.querySelectorAll('a[href="/cart"]').forEach(a => {
    if (a.dataset.cartWired) return;
    a.dataset.cartWired = "1";
    a.addEventListener("click", e => {
      e.preventDefault();
      openDrawer();
    });
  });
}

/* ───────────────────────── mobile menu drawer ───────────────────────── */

function wireMobileMenu() {
  const wrap = document.getElementById("se-drawer-wrap");
  const ov = document.getElementById("se-drawer-overlay");
  const burger = document.getElementById("se-mobile-bar-burger");
  if (!wrap || !ov || !burger) return;
  const open = () => {
    wrap.classList.add("on");
    ov.classList.add("on");
    document.body.style.overflow = "hidden";
  };
  const close = () => {
    wrap.classList.remove("on");
    ov.classList.remove("on");
    document.body.style.overflow = "";
  };
  burger.addEventListener("click", open);
  ov.addEventListener("click", close);
  const wireClose = () => {
    const x = document.querySelector('#se-mobile-header-root button[aria-label="Close"]');
    if (x && !x.dataset.menuWired) {
      x.dataset.menuWired = "1";
      x.addEventListener("click", close);
    }
  };
  wireClose();
  new MutationObserver(wireClose).observe(document.getElementById("se-mobile-header-root"), {
    childList: true,
    subtree: true
  });
  document.addEventListener("keydown", e => {
    if (e.key === "Escape") close();
  });
}

/* ───────────────────────── footer data ───────────────────────── */

const FOOTER_LINKS = {
  Shop: [{
    l: "Equine",
    h: "/collections/equine"
  }, {
    l: "Canine",
    h: "/collections/small-pets"
  }, {
    l: "Subscribe & Save",
    h: "/products/subscriptions"
  }, {
    l: "Gift cards",
    h: "/products/gift-card"
  }],
  Learn: [{
    l: "What is Camelina",
    h: "/pages/about-us"
  }, {
    l: "Reviews",
    h: "/pages/reviews"
  }, {
    l: "Equine FAQs",
    h: "/pages/equine-faqs"
  }, {
    l: "Canine FAQs",
    h: "/pages/canine-faqs"
  }, {
    l: "Blog",
    h: "/blogs/news"
  }],
  Company: [{
    l: "Partners",
    h: "/pages/partner"
  }, {
    l: "Become an Ambassador",
    h: "https://form.typeform.com/to/w7v211Kx",
    x: 1
  }, {
    l: "Find a store",
    h: "/pages/store-finder"
  }, {
    l: "Contact us",
    h: "/pages/contact"
  }, {
    l: "Refund policy",
    h: "/pages/refund-policy"
  }, {
    l: "Privacy",
    h: "/pages/privacy-policy"
  }]
};
const SOCIALS = [{
  l: "Instagram",
  h: "https://instagram.com/smartearthcamelina"
}, {
  l: "Facebook",
  h: "https://facebook.com/smartearthusa"
}, {
  l: "YouTube",
  h: "https://www.youtube.com/channel/UCyCU0tctVFYHxqB4_czI7aA"
}, {
  l: "Twitter",
  h: "https://twitter.com/smartearthseeds"
}];

/* ───────────────────────── desktop footer ───────────────────────── */

function FooterDesktop() {
  const bg = "#FAFAF7";
  const surface = "#FFFFFF";
  const {
    ink,
    green,
    muted,
    rule
  } = tokens;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      background: bg,
      color: ink,
      fontFamily: "'Raleway', sans-serif",
      borderTop: `1px solid ${rule}`
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 1440,
      margin: "0 auto",
      padding: "56px 40px 0"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "grid",
      gridTemplateColumns: "1.1fr 1fr",
      gap: 64,
      alignItems: "center",
      paddingBottom: 48,
      borderBottom: `1px solid ${rule}`
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
    style: {
      margin: 0,
      fontSize: 44,
      fontWeight: 500,
      letterSpacing: "-0.035em",
      lineHeight: 1.05,
      maxWidth: 540
    }
  }, "Healthier animals. ", /*#__PURE__*/React.createElement("span", {
    style: {
      color: green
    }
  }, "Smarter inbox.")), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: "12px 0 0",
      fontSize: 14,
      color: muted,
      lineHeight: 1.55,
      maxWidth: 460
    }
  }, "Get research-backed tips for horses & dogs, early access to new releases, and the occasional barn story.")), /*#__PURE__*/React.createElement("form", {
    action: "/contact#contact_form",
    method: "post",
    acceptCharset: "UTF-8",
    style: {
      display: "flex",
      flexDirection: "column",
      gap: 12
    }
  }, /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    name: "form_type",
    value: "customer"
  }), /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    name: "utf8",
    value: "\u2713"
  }), /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    name: "contact[tags]",
    value: "newsletter"
  }), /*#__PURE__*/React.createElement("label", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: 0,
      padding: 4,
      paddingLeft: 18,
      background: surface,
      border: `1px solid ${rule}`,
      borderRadius: 999
    }
  }, /*#__PURE__*/React.createElement("input", {
    type: "email",
    name: "contact[email]",
    required: true,
    placeholder: "your@email.com",
    style: {
      flex: 1,
      border: "none",
      outline: "none",
      background: "transparent",
      fontFamily: "'Montserrat', monospace",
      fontSize: 13,
      color: ink,
      padding: "10px 8px"
    }
  }), /*#__PURE__*/React.createElement("button", {
    type: "submit",
    style: {
      background: ink,
      color: "#fff",
      border: "none",
      borderRadius: 999,
      padding: "12px 22px",
      fontWeight: 600,
      fontSize: 13,
      fontFamily: "'Montserrat', monospace",
      letterSpacing: "0.06em",
      cursor: "pointer"
    }
  }, "SUBSCRIBE \u2192")), /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 11,
      color: muted,
      fontFamily: "'Montserrat', monospace",
      letterSpacing: "0.06em"
    }
  }, "By subscribing you agree to our ", /*#__PURE__*/React.createElement("a", {
    href: "/pages/privacy-policy",
    style: {
      color: ink,
      textDecoration: "underline"
    }
  }, "privacy policy"), "."))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "grid",
      gridTemplateColumns: "1.4fr repeat(3, 1fr) 1.2fr",
      gap: 48,
      padding: "48px 0"
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("a", {
    href: "/",
    style: {
      display: "inline-flex",
      alignItems: "center",
      textDecoration: "none",
      color: ink,
      lineHeight: 0
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: LOGO_URL,
    alt: "Smart Earth Camelina",
    style: {
      height: 38,
      width: "auto",
      display: "block"
    }
  })), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: "18px 0 0",
      fontSize: 13,
      color: muted,
      lineHeight: 1.55,
      maxWidth: 280
    }
  }, "Single-ingredient camelina oil for horses and dogs. Grown, pressed, and bottled in Canada."), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 18,
      fontFamily: "'Montserrat', monospace",
      fontSize: 10,
      letterSpacing: "0.16em",
      textTransform: "uppercase",
      color: muted,
      display: "flex",
      flexDirection: "column",
      gap: 6
    }
  }, /*#__PURE__*/React.createElement("span", null, "NON-GMO \xB7 COLD-PRESSED"), /*#__PURE__*/React.createElement("span", null, "EST. 2009 \xB7 CANADA"))), Object.entries(FOOTER_LINKS).map(([heading, items]) => /*#__PURE__*/React.createElement("div", {
    key: heading
  }, /*#__PURE__*/React.createElement("h3", {
    style: {
      margin: 0,
      fontFamily: "'Montserrat', monospace",
      fontSize: 11,
      color: green,
      letterSpacing: "0.2em",
      textTransform: "uppercase",
      fontWeight: 500
    }
  }, "[ ", heading, " ]"), /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: "none",
      margin: "16px 0 0",
      padding: 0,
      display: "flex",
      flexDirection: "column",
      gap: 10
    }
  }, items.map(it => /*#__PURE__*/React.createElement("li", {
    key: it.l
  }, /*#__PURE__*/React.createElement("a", {
    href: it.h,
    target: it.x ? "_blank" : void 0,
    rel: it.x ? "noopener noreferrer" : void 0,
    style: {
      textDecoration: "none",
      color: ink,
      fontSize: 14,
      fontWeight: 500
    }
  }, it.l)))))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
    style: {
      margin: 0,
      fontFamily: "'Montserrat', monospace",
      fontSize: 11,
      color: green,
      letterSpacing: "0.2em",
      textTransform: "uppercase",
      fontWeight: 500
    }
  }, "[ Connect ]"), /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: "none",
      margin: "16px 0 0",
      padding: 0,
      display: "flex",
      flexDirection: "column",
      gap: 10
    }
  }, SOCIALS.map(s => /*#__PURE__*/React.createElement("li", {
    key: s.l
  }, /*#__PURE__*/React.createElement("a", {
    href: s.h,
    target: "_blank",
    rel: "noopener",
    style: {
      textDecoration: "none",
      color: ink,
      fontSize: 14,
      fontWeight: 500,
      display: "inline-flex",
      alignItems: "center",
      gap: 8
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      width: 6,
      height: 6,
      borderRadius: "50%",
      background: green
    }
  }), " ", s.l)))), /*#__PURE__*/React.createElement("a", {
    href: "mailto:sales@smartearthseeds.com",
    style: {
      marginTop: 18,
      display: "inline-flex",
      alignItems: "center",
      gap: 8,
      color: ink,
      textDecoration: "none",
      fontFamily: "'Montserrat', monospace",
      fontSize: 12,
      letterSpacing: "0.06em",
      borderBottom: `1px solid ${ink}`,
      paddingBottom: 2
    }
  }, "sales@smartearthseeds.com \u2192"))), /*#__PURE__*/React.createElement("div", {
    style: {
      borderTop: `1px solid ${rule}`,
      padding: "20px 0 28px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 24,
      fontFamily: "'Montserrat', monospace",
      fontSize: 11,
      letterSpacing: "0.12em",
      textTransform: "uppercase",
      color: muted
    }
  }, /*#__PURE__*/React.createElement("span", null, "\xA9 ", new Date().getFullYear(), " Smart Earth Camelina Corp."), /*#__PURE__*/React.createElement("span", {
    style: {
      display: "inline-flex",
      gap: 24
    }
  }, /*#__PURE__*/React.createElement("a", {
    href: "/pages/privacy-policy",
    style: {
      color: muted,
      textDecoration: "none"
    }
  }, "Privacy"), /*#__PURE__*/React.createElement("a", {
    href: "/pages/refund-policy",
    style: {
      color: muted,
      textDecoration: "none"
    }
  }, "Refunds"), /*#__PURE__*/React.createElement("a", {
    href: "/pages/contact",
    style: {
      color: muted,
      textDecoration: "none"
    }
  }, "Contact"), /*#__PURE__*/React.createElement("a", {
    href: "/pages/terms-of-service",
    style: {
      color: muted,
      textDecoration: "none"
    }
  }, "Terms")), /*#__PURE__*/React.createElement("span", {
    style: {
      display: "inline-flex",
      alignItems: "center",
      gap: 8
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      width: 6,
      height: 6,
      borderRadius: "50%",
      background: green
    }
  }), "All systems operational"))));
}

/* ───────────────────────── mobile footer ───────────────────────── */

function FooterMobile() {
  const bg = "#FAFAF7";
  const surface = "#FFFFFF";
  const {
    ink,
    green,
    muted,
    rule
  } = tokens;
  const [open, setOpen] = React.useState("Shop");
  return /*#__PURE__*/React.createElement("div", {
    style: {
      background: bg,
      color: ink,
      fontFamily: "'Raleway', sans-serif",
      borderTop: `1px solid ${rule}`,
      padding: "32px 18px 28px"
    }
  }, /*#__PURE__*/React.createElement("a", {
    href: "/",
    style: {
      display: "inline-flex",
      textDecoration: "none",
      lineHeight: 0
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: LOGO_URL,
    alt: "Smart Earth Camelina",
    style: {
      height: 34,
      width: "auto"
    }
  })), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: "16px 0 0",
      fontSize: 13.5,
      color: muted,
      lineHeight: 1.55
    }
  }, "Single-ingredient camelina oil for horses and dogs. Grown, pressed and bottled in Canada."), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 24,
      padding: 16,
      background: surface,
      border: `1px solid ${rule}`,
      borderRadius: 14
    }
  }, /*#__PURE__*/React.createElement("h3", {
    style: {
      margin: "0 0 12px",
      fontSize: 18,
      fontWeight: 500,
      letterSpacing: "-0.02em"
    }
  }, "Better barn intel, monthly."), /*#__PURE__*/React.createElement("form", {
    action: "/contact#contact_form",
    method: "post",
    acceptCharset: "UTF-8",
    style: {
      display: "flex",
      gap: 8
    }
  }, /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    name: "form_type",
    value: "customer"
  }), /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    name: "utf8",
    value: "\u2713"
  }), /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    name: "contact[tags]",
    value: "newsletter"
  }), /*#__PURE__*/React.createElement("input", {
    type: "email",
    name: "contact[email]",
    required: true,
    placeholder: "you@example.com",
    style: {
      flex: 1,
      border: `1px solid ${rule}`,
      borderRadius: 999,
      background: bg,
      padding: "10px 14px",
      fontFamily: "'Montserrat', monospace",
      fontSize: 12,
      color: ink,
      outline: "none"
    }
  }), /*#__PURE__*/React.createElement("button", {
    type: "submit",
    style: {
      background: ink,
      color: "#fff",
      border: "none",
      borderRadius: 999,
      padding: "0 18px",
      fontWeight: 600,
      fontSize: 12,
      fontFamily: "'Montserrat', monospace",
      letterSpacing: "0.06em",
      cursor: "pointer"
    }
  }, "JOIN \u2192"))), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 16,
      borderTop: `1px solid ${rule}`
    }
  }, Object.entries(FOOTER_LINKS).map(([heading, items]) => /*#__PURE__*/React.createElement("div", {
    key: heading,
    style: {
      borderBottom: `1px solid ${rule}`
    }
  }, /*#__PURE__*/React.createElement("button", {
    onClick: () => setOpen(open === heading ? null : heading),
    style: {
      width: "100%",
      background: "transparent",
      border: "none",
      padding: "14px 0",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      cursor: "pointer",
      color: ink
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: "'Montserrat', monospace",
      fontSize: 11,
      color: green,
      letterSpacing: "0.2em",
      textTransform: "uppercase",
      fontWeight: 500
    }
  }, "[ ", heading, " ]"), /*#__PURE__*/React.createElement("span", {
    style: {
      color: muted,
      transition: "transform .2s",
      transform: open === heading ? "rotate(45deg)" : "rotate(0)",
      fontSize: 18,
      fontWeight: 300
    }
  }, "+")), open === heading && /*#__PURE__*/React.createElement("ul", {
    style: {
      listStyle: "none",
      margin: 0,
      padding: "0 0 14px",
      display: "flex",
      flexDirection: "column",
      gap: 10
    }
  }, items.map(it => /*#__PURE__*/React.createElement("li", {
    key: it.l
  }, /*#__PURE__*/React.createElement("a", {
    href: it.h,
    target: it.x ? "_blank" : void 0,
    rel: it.x ? "noopener noreferrer" : void 0,
    style: {
      textDecoration: "none",
      color: ink,
      fontSize: 14,
      fontWeight: 500
    }
  }, it.l))))))), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 20,
      display: "flex",
      gap: 8,
      flexWrap: "wrap"
    }
  }, SOCIALS.map(s => /*#__PURE__*/React.createElement("a", {
    key: s.l,
    href: s.h,
    target: "_blank",
    rel: "noopener",
    style: {
      textDecoration: "none",
      color: ink,
      fontSize: 12,
      padding: "8px 14px",
      border: `1px solid ${rule}`,
      borderRadius: 999,
      fontFamily: "'Montserrat', monospace",
      letterSpacing: "0.08em",
      textTransform: "uppercase",
      background: surface
    }
  }, s.l, " \u2197"))), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 24,
      paddingTop: 18,
      borderTop: `1px solid ${rule}`,
      display: "flex",
      flexDirection: "column",
      gap: 10,
      fontFamily: "'Montserrat', monospace",
      fontSize: 10,
      letterSpacing: "0.14em",
      textTransform: "uppercase",
      color: muted
    }
  }, /*#__PURE__*/React.createElement("span", null, "\xA9 ", new Date().getFullYear(), " Smart Earth Camelina Corp."), /*#__PURE__*/React.createElement("span", {
    style: {
      display: "inline-flex",
      gap: 16,
      flexWrap: "wrap"
    }
  }, /*#__PURE__*/React.createElement("a", {
    href: "/pages/privacy-policy",
    style: {
      color: muted,
      textDecoration: "none"
    }
  }, "Privacy"), /*#__PURE__*/React.createElement("a", {
    href: "/pages/refund-policy",
    style: {
      color: muted,
      textDecoration: "none"
    }
  }, "Refunds"), /*#__PURE__*/React.createElement("a", {
    href: "/pages/contact",
    style: {
      color: muted,
      textDecoration: "none"
    }
  }, "Contact"))));
}

/* ───────────────────────── boot ───────────────────────── */

function boot() {
  const desktopRoot = document.getElementById("se-header-root");
  const mobileRoot = document.getElementById("se-mobile-header-root");
  const footerRoot = document.getElementById("se-footer-root");
  const mobileFooterRoot = document.getElementById("se-mobile-footer-root");
  if (desktopRoot) ReactDOM.createRoot(desktopRoot).render(/*#__PURE__*/React.createElement(HeaderDesktop, null));
  if (mobileRoot) ReactDOM.createRoot(mobileRoot).render(/*#__PURE__*/React.createElement(HeaderMobile, null));
  if (footerRoot) ReactDOM.createRoot(footerRoot).render(/*#__PURE__*/React.createElement(FooterDesktop, null));
  if (mobileFooterRoot) ReactDOM.createRoot(mobileFooterRoot).render(/*#__PURE__*/React.createElement(FooterMobile, null));

  // Cart link interception (must run after React commits)
  setTimeout(() => {
    wireCartLinks();
    wireMobileMenu();
    new MutationObserver(wireCartLinks).observe(document.body, {
      childList: true,
      subtree: true
    });

    // Sticky-header shadow on scroll
    const hroot = document.getElementById("se-header-root");
    const mbar = document.getElementById("se-mobile-bar");
    const onScroll = () => {
      const stuck = window.scrollY > 4;
      if (hroot) hroot.classList.toggle("is-stuck", stuck);
      if (mbar) mbar.classList.toggle("is-stuck", stuck);
    };
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    onScroll();
  }, 50);

  // Refresh cart count when other code adds to cart via jQuery/AJAX
  // Wokiee theme dispatches its own events; listen for the common ones.
  ["ajax:complete", "ajaxComplete", "shopify:section:load"].forEach(ev => {
    document.addEventListener(ev, () => {
      window.dispatchEvent(new CustomEvent("se:cart-updated"));
    });
  });
}
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot);
} else {
  boot();
}
